export default __webpack_public_path__ + "static/media/template-1.ed7312ae.png";